import { Section } from '@advanza/advanza_generic'
import { Divider } from '@advanza/ui'
import Page from 'components/ui/Page'
import PropTypes from 'prop-types'
import React from 'react'
import { useParams } from 'react-router-dom'
import RequestView from './RequestView'

class RequestViewPage extends React.Component {
    render() {
        const { id, source } = this.props
        return (
            <Page title="Requests">
                <Section x>
                    <RequestView requestId={id} filterSource={source || 'default'} />
                </Section>
                <Divider xxl />
            </Page>
        )
    }
}

RequestViewPage.propTypes = {
    requestId: PropTypes.any,
    id: PropTypes.any,
    source: PropTypes.any,
}

const RequestViewPageWrapper = (props) => {
    const { id, source } = useParams()
    return <RequestViewPage {...props} id={id} source={source} />
}

export default RequestViewPageWrapper
